import {Outlet, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import Layout from "./pages/layout.tsx";
import React, {useEffect, useRef, useState} from "react";
import AuthService from "@/services/auth.ts";
import "./App.css";
import type {Teams, UserInfo} from "@/types";
import useRouterContext from '@/hooks/useRouterContext';
import useGlobalModelInit from '@/hooks/useGlobalModelInit';
import useUserInfoInit from '@/hooks/useUserInfoInit';
import usePreventPullToRefresh from '@/hooks/usePreventPullToRefresh';
import { useIsMobile } from "@/hooks/use-mobile";
import { useViewportHeight } from "@/hooks/useViewportHeight";
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import {Toaster} from "@/components/ui/sonner.tsx";
import ErrorBoundary from "@/components/ErrorBoundary";
import { envStorage } from "./utils/envCache.js";
import { getDefaultBrandConfigForHost, getSavedSourceSystemConfig, saveSourceSystem } from "@/config/sourceSystem";
import { applyDocumentBrand } from "@/utils/sourceSystemBrand";

// 注册所有社区版模块
ModuleRegistry.registerModules([AllCommunityModule]);

export default function App() {
    useViewportHeight(); // Set viewport height for mobile browsers
    useRouterContext();
    useGlobalModelInit(); // 初始化全局模型
    useUserInfoInit(); // 初始化用户信息
    usePreventPullToRefresh(); // 防止移动端下拉抖动
    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const currentPath = location.pathname;

    // 使用 ref 跟踪登录请求状态
    const loginRequested = useRef(false);
    const [userInfo, setUserInfo] = useState<UserInfo | null>();
    const token = AuthService.getAccessToken();

    useEffect(() => {
        const sourceSystem = searchParams.get("sourceSystem");
        const brandConfig = currentPath.startsWith('/admin')
            ? getDefaultBrandConfigForHost()
            : sourceSystem
                ? saveSourceSystem(sourceSystem)
                : getSavedSourceSystemConfig();
        applyDocumentBrand(brandConfig);
    }, [currentPath, searchParams]);

    useEffect(() => {

        // HKAI 第三方登录页面不做登录拦截，让其自行处理
        if (currentPath.startsWith('/open/')) {
            return;
        }

        // 如果是移动端、未登录，则重定向到登录页
        if (isMobile && !token) {
            navigate("/login", { replace: false });
        }

        // 如果是桌面端，但访问了登录页，则重定向到首页
        if (!isMobile && location.pathname === '/login') {
            navigate("/", { replace: true });
        }
    }, [isMobile, token, navigate]);

    useEffect(() => {
        // 确保登录请求只执行一次
        if (loginRequested.current) return;
        loginRequested.current = true;

        async function fetchData() {

            if (!token) {
               /* try {
                    const teamList = await AuthService.teamQuery('dltc@outlook.com') as Teams[]
                    if (teamList.length == 0) {
                        return
                    }

                    if (teamList.length == 1) {
                        console.log(teamList)
                        const res = await AuthService.login({
                            email: "dltc@outlook.com",
                            teamId: teamList[0].teamId,
                            password: "a12345"
                        });

                        if (res) {
                            // navigate('/user')
                            setUserInfo(res);
                            setUser(res);
                            AuthService.setUserInfo(res);
                        }
                    }
                } catch (error) {
                    console.error("登录失败:", error);
                }*/
            } else {
                // navigate('/user')
                const info = AuthService.getUserInfo();
                console.log("用户信息:", info)
                setUserInfo(info);
            }
        }

        fetchData();
    }, []);
    // 当前路由的路径  用路径判断走的布局
    const isSpecialPage = currentPath === '/special';
    const isThread = currentPath.startsWith('/thread');
    const isCheck = currentPath.startsWith('/admin/fileDataEditor');
    const isTopicDetail = currentPath.startsWith('/admin/topicDetail');
    const isOpenPage = currentPath.startsWith('/open/');
    console.log('currentPath:',currentPath)
    // console.log(isSpecialPage)
    // 是否登录的是管理后台标识
    const admin = envStorage.getItem("admin") === "true";
    console.log(admin)

    return (
        <ErrorBoundary>
            <div>
                <Toaster position="top-center" style={{color: "black"}} />
                {
                    isSpecialPage || isThread ||isCheck ||isTopicDetail || isOpenPage ? (
                            <Outlet/>
                        ) :
                        (
                            <div>
                                <div className="bg-[var(--background-left_navigation_web)] overflow-x-hidden">
                                    <div className="flex h-full">
                                        {/* 固定侧边栏 */}
                                        <div className={'bg-[var(--background-left_navigation_web)]'}>
                                            <Layout/>
                                        </div>
                                        <main className="flex-1 md:p-[6px] app-content flex h-full">
                                            <Outlet/>
                                        </main>
                                    </div>
                                </div>

                        </div>
                        )
                }
            </div>
        </ErrorBoundary>
    );
}
